/* THE COLLECTORS VAULT — Theme JS */

// Scroll reveal animations
document.addEventListener('DOMContentLoaded', function() {
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.tcv-reveal').forEach(function(el) {
    observer.observe(el);
  });

  // Mobile menu toggle
  var menuToggle = document.querySelector('.tcv-menu-toggle');
  var mobileMenu = document.querySelector('.tcv-mobile-menu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('open');
      menuToggle.classList.toggle('open');
    });
  }
});
